import { Component,  ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { NavigationService } from 'src/app/services/navigation.service';

declare var $: any; // Declarar jQuery para TypeScript

declare var bootstrap: any;

@Component({
  selector: 'app-usuarios-d',
  templateUrl: './usuarios-d.component.html',
  styleUrls: ['./usuarios-d.component.css']
})
export class UsuariosDComponent {

  @ViewChild('rolesEliminadosModal', { static: false }) rolesEliminadosModal!: ElementRef; // Referencia al modal

  user = {
    username: '',
    nombre: '',
    ap_paterno: '',
    ap_materno: '',
    correo: '',
    rol: 0 as number | number[],
    roles: '',
    rolDelete: ''
  }

  opE: any;
  roles: any[] = [];
  token: any;
  retrievedUser: any;

  // declaración de los mensajes de validación 
  showErrorMessageUser: boolean = false;
  showErrorMessageRol: boolean = false;
  showErrorMessageNom: boolean = false;
  showErrorMessageAP: boolean = false;
  showErrorMessageAM: boolean = false;

  mensajeValidacionUser: string = '';
  mensajeValidacionRol: string = '';
  mensajeValidacionNom: string = '';
  mensajeValidacionAP: string = '';
  mensajeValidacionAM: string = '';

  mensaje: string = 'Campo requerido.';

  public _value: any[] = [];

  public rolLlegada : any;

  numeroRolesEliminados: string = '';
  nombreRolesEliminados: string = '';

  modalInstance: any; // Instancia del modal
  banderaRoles: boolean = false;
  mensajeRoles: string = '';
  llegadaCortada:any;


  mostrarInput: any = [
    { value: "0: 7" },
    { value: "1: 3" },
    { value: "2: 2" },
    { value: "3: 8" },
    { value: "4: 4" },
    { value: "5: 1" }
  ];
  
  botonEditar: boolean = true;

  iconoMostrar: string = '';
  nameBoton: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private messagesService: MessagesService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.obtenerToken();
    this.obtnerRoles();
    this.obtnerIcono();
  }

  obtnerIcono(){

    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  ngAfterViewInit() {
    // Inicializa select2
    $('#rol').select2({
      placeholder: 'Seleccionar rol...',
      multiple: true
    }).on('change', (e: any) => {
      let selectedValues = $(e.target).val();

      this.validacionesSelct(selectedValues);

    }).on('select2:close', (e: any) => {
      // Llamar a mostrarMensaje solo si el campo está sucio o tocado
      this.mostrarMensaje(this.user.rol, 'rol');
    });


    const modalElement = this.rolesEliminadosModal.nativeElement; // Referencia al modal
    this.modalInstance = new bootstrap.Modal(modalElement); // Crear el modal de Bootstrap

  }

  validacionesSelct(selectedValues: any){
    if (selectedValues.length === 0) {
      this.botonEditar = false;
      // Si selecciona más de 2 roles, mostrar error
      this.mostrarError('Debes seleccionar al menos un rol.');
      
      // Eliminar el último rol seleccionado
      selectedValues.pop();

      // Actualizar el valor en select2 con los dos primeros roles
      $('#rol').val(selectedValues).trigger('change');
    }

    this.botonEditar = true;
    if (selectedValues.length > 2) {
      // Si selecciona más de 2 roles, mostrar error
      this.mostrarError('No se pueden seleccionar más de dos roles');
      
      // Eliminar el último rol seleccionado
      selectedValues.pop();

      // Actualizar el valor en select2 con los dos primeros roles
      $('#rol').val(selectedValues).trigger('change');
    }
      // Procesa los valores para extraer solo el Id_Rol (parte después del `:`)
      this.user.rol = selectedValues ? selectedValues.map((val: string) => {
        const parts = val.split(':');
        return Number(parts[1].trim());  // Extraer solo la segunda parte, que es el Id_Rol
      }) : [];
    

  }

  obtenerToken() {
    this.token = String(localStorage.getItem('token1'))
    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');
    if (this.opE === '1') {//obtengo creditor para actualizar
      this.retrievedUser = this.sharedService.getDataArray();
      this.cargarUser(this.retrievedUser);
    }
  }

  obtnerRoles() {
    this.requestsService.getAllRol(this.token).subscribe(
      (data: any) => {
        this.roles = Object.values(data);
      });
  }

  async cargarUser(getuser: any) {
    this.user.username = getuser.Usr_Username;
    this.user.nombre = getuser.Usr_Nombre;
    this.user.ap_paterno = getuser.Usr_Apellido_Paterno;
    this.user.ap_materno = getuser.Usr_Apellido_Materno;
    this.user.correo = getuser.Usr_Correo;
    
    if (getuser.rol !== undefined) {
      this.rolLlegada = getuser.rol;
      this.user.rol = getuser.rol;
      this.user.rol = Array.isArray(getuser.rol) ? getuser.rol : [getuser.rol];
      
    } else {
      this.rolLlegada = getuser.roles;
      // Si getuser.roles es un número, conviértelo en un array
      this.user.rol = Array.isArray(getuser.roles) ? getuser.roles : (typeof getuser.roles === 'number') ? [getuser.roles] : (typeof getuser.roles === 'string') ? getuser.roles.split(',').map(Number) : [];
    }
    this.setSelectedRoles();
  }

  setSelectedRoles() {
    this.botonEditar = this.user.rol !== 0;

    // Asegurar que sea un array antes de asignarlo a Select2
    if (Array.isArray(this.user.rol)) {
      $('#rol').val(this.user.rol).trigger('change');
    } else if (typeof this.user.rol === 'number') {
      $('#rol').val([this.user.rol]).trigger('change');
    } else {
      console.error('Tipo inesperado para this.user.rol:', this.user.rol);
      $('#rol').val([]).trigger('change'); // Vaciar el select si no es válido
    }
  }


  async validaFormulario(guardar: any, editar: any) {

    if (this.user.nombre === '' || this.user.ap_paterno === '' || this.user.ap_materno === '' || this.user.username === '' || this.user.rol === 0) {
      this.mostrarError('Todos los campos son obligatorios');
      return;
    }
    if (!this.isValidEmail(this.user.username)) {
      this.mostrarError('Ingrese un correo electrónico válido');
      return;
    }
    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar('editar')
    }
  }
  
showModal() {
  if (this.modalInstance) {
    this.mensajeRoles = `${this.nombreRolesEliminados}`;
    this.modalInstance.show(); // Mostrar el modal
  }
}


  // Método cuando se presiona el botón "Aceptar"
  onAccept() {
    if (this.modalInstance) {
      this.banderaRoles = false;
      this.modalInstance.hide(); // Asegurarse de que la instancia del modal existe antes de cerrarlo
      this.user.rolDelete = this.nombreRolesEliminados;
      this.editar('boton'); // Continuar con la acción
    }
  }

  // Método cuando se presiona el botón "Cerrar"
  onClose() {
    if (this.modalInstance) {
      this.modalInstance.hide(); // Asegurarse de que la instancia del modal existe antes de cerrarlo
      this.recargarRolesLlegada();
    }
  }

  recargarRolesLlegada() {
    // Armar los valores en el formato "índice: valor"
    this.user.rol = this.mostrarInput
    .map((input: any) => input.value) // Extraer el valor de cada objeto
    .filter((value: string) => {
      const valorSeparado = value.split(':')[1].trim(); // Obtener la parte después de los ":"
      // Comparar con this.llegadaCortada y devolver los que coincidan
      return this.llegadaCortada.includes(Number(valorSeparado));
    });  
    // Llamar a la función para seleccionar los roles
    this.setSelectedRoles();
  }

  verificacionRoles() {
    this.banderaRoles = false;
    if(this.rolLlegada !== 14){

      // Obtener los valores del objeto this.user.rol como un array de números
      let userRolArray = Object.values(this.user.rol).map((rol: unknown) => {
        if (typeof rol === 'string') {
          return parseInt(rol, 10);
        } else if (typeof rol === 'number') {
          return rol;
        } else {
          throw new Error('El valor del rol no es un número ni una cadena');
        }
      });
  
      // Convertir this.rolLlegada en un array de números
      if(Number.isFinite(this.rolLlegada)){
        this.llegadaCortada = [this.rolLlegada];
      }else{
        this.llegadaCortada = this.rolLlegada.split(',').map((rol: string) => parseInt(rol.trim(), 10));
      }   
    
      // Crear sets para facilitar la comparación
      let setCortado = new Set<number>(this.llegadaCortada);
      let setUserRol = new Set<number>(userRolArray);
    
      // Roles eliminados (están en llegadaCortada pero no en user.rol)
      let rolesEliminados = [...setCortado].filter((rol: number) => !setUserRol.has(rol));
    
      // Verificar si alguno de los roles eliminados es el rol 3 o 4
      const rolesCriticos = rolesEliminados.filter((rol: number) => rol === 3 || rol === 4);
    
      // Si se eliminó un rol crítico (3 o 4), mostrar el modal
      if (rolesCriticos.length > 0) {
        // Aquí filtramos los detalles de los roles eliminados basándonos en su Id_Rol
        let detallesRolesEliminados = this.roles.filter((rol: any) => rolesEliminados.includes(rol.Id_Rol));
    
        // Guardar los IDs de los roles eliminados y convertirlos a un string separado por comas
        this.numeroRolesEliminados = detallesRolesEliminados.map((rol: any) => rol.Id_Rol).join(', ');
    
        // Guardar los nombres de los roles eliminados y convertirlos a un string separado por comas
        this.nombreRolesEliminados = detallesRolesEliminados.map((rol: any) => rol.Rls_Nombre).join(', ');
    
        this.banderaRoles = true;
    
        // Mostrar el modal con los roles eliminados
        this.showModal();
      }
    }
  }

  cambiarDatos() {
 
    // this.user.rol es un array de números
    let numeros: number[] = Array.isArray(this.user.rol) ? this.user.rol : [this.user.rol];

    // Convertir el array de números a un string separado por comas
    this.user.roles = numeros.join(',');

    // cambiamos el this.user.rol por un 14 que son varios selección
    this.user.rol = 14;

    // Guardamos los lo que se coloco en el username en el correo
    this.user.correo = this.user.username;
  }

  editar(clic:string) {
    if(clic === 'editar'){
      this.verificacionRoles(); 
    }

    if(this.banderaRoles === false){
      this.cambiarDatos();
      this.requestsService.editUser(this.user, this.retrievedUser.Id_Usuario, this.token).subscribe(
        (res) => {
          this.confirmacion(res.message);
        }, (err) => {
          this.mostrarError(err.message);
        }
      )
    }

  }

  guardar() {
    this.cambiarDatos();
    this.requestsService.createUser(this.user, this.token).subscribe(
      (res) => {
        this.confirmacion(res.message);
      }, (err) => {
        if (err.status === 403) {
          this.mostrarError(`El usuario ${this.user.correo} ya existe`);
        } else {
          this.mostrarError(err.message);
        }
      }
    )
  }

  eliminar() {
    this.requestsService.deleteUser(this.retrievedUser.Id_Usuario, this.token).subscribe(
      (res) => {
        this.confirmacion(res.message);
      }, (err) => {
        this.mostrarError(err.message);
      }
    )
  }

  confirmacion(mensajeConfirmacion: string) {
    this.messagesService.showMessage(mensajeConfirmacion);
    this.cancelar();
  }

  mostrarError(mensajeError: string) {
    this.messagesService.showError(mensajeError);
  }

  cancelar() {
    this.router.navigate(['/usuarios']);
  }

  private isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  private isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'userName':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageUser = true;
          this.mensajeValidacionUser = this.mensaje;
        } else {
          this.showErrorMessageUser = false;
        }
        break;
      case 'rol':
        if (campo.length === 0) {
          this.showErrorMessageRol = true;
          this.mensajeValidacionRol = this.mensaje;
        } else {
          this.showErrorMessageRol = false;
        }
        break;
      case 'nombre':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageNom = true;
          this.mensajeValidacionNom = this.mensaje;
        } else {
          this.showErrorMessageNom = false;
        }
        break;
      case 'ap_paterno':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageAP = true;
          this.mensajeValidacionAP = this.mensaje;
        } else {
          this.showErrorMessageAP = false;
        }
        break;
      case 'ap_materno':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageAM = true;
          this.mensajeValidacionAM = this.mensaje;
        } else {
          this.showErrorMessageAM = false;
        }
        break;
    }
  }
}